import produce from 'immer';
import _ from 'lodash';
import objFromArray from 'src/utils/objFromArray';
import {
  GET_TOTAL_STAFF,
  ADD_STAFF,
  UPDATE_STAFF,
  DELETE_STAFF,
  RESET_PASSWORD
} from 'src/actions/staffActions';

const initialState = {
  allIds: [],
  byId: {},
  tempPassword: []
};

const totalStaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOTAL_STAFF: {
      const { staffs } = action.payload;
      return produce(state, draft => {
        draft.byId = objFromArray(staffs);
        draft.allIds = Object.keys(draft.byId);
      });
    }

    case ADD_STAFF: {
      const { staff } = action.payload;

      return produce(state, draft => {
        draft.byId[staff.id] = staff;
        draft.allIds.push(staff.id);
        draft.tempPassword = staff.pass;
      });
    }

    case UPDATE_STAFF: {
      const { staff } = action.payload;
      return produce(state, draft => {
        draft.byId[staff.id] = staff;
        if (!draft.allIds.includes(staff.id)) {
          draft.allIds.push(staff.id);
        }
      });
    }
    case DELETE_STAFF: {
      const { id } = action.payload;
      return produce(state, draft => {
        draft.byId = _.omit(draft.byId, id);
        _.pull(draft.allIds, id);
      });
    }
    case RESET_PASSWORD: {
      const { staff } = action.payload;
      return produce(state, draft => {
        draft.byId[staff.id] = staff;

        if (!draft.allIds.includes(staff.id)) {
          draft.allIds.push(staff.id);
        }
      });
    }

    default: {
      return state;
    }
  }
};
export default totalStaffReducer;
